export default __webpack_public_path__ + "static/media/plantillaProveedores.e43fa62a.xlsx";